"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarginCallStatus = exports.DrawLockStatus = exports.CryptoTransferStatus = exports.CryptoTransferType = exports.LiquidationType = exports.CryptoAccountHealthStatus = exports.AvenArgosAccountMonitoringStrategy = void 0;
/**
 * @TranslateToRust
 */
var AvenArgosAccountMonitoringStrategy;
(function (AvenArgosAccountMonitoringStrategy) {
    AvenArgosAccountMonitoringStrategy["BitcoinSeventyOltv"] = "20260121_bitcoin_70_oltv";
    AvenArgosAccountMonitoringStrategy["BitcoinFiftyOltv"] = "20260121_bitcoin_50_oltv";
    AvenArgosAccountMonitoringStrategy["BitcoinThirtyOltv"] = "20260121_bitcoin_30_oltv";
    AvenArgosAccountMonitoringStrategy["NinetyNinePercentFullLiquidation"] = "20260121_99_percent_full_liquidation";
})(AvenArgosAccountMonitoringStrategy || (exports.AvenArgosAccountMonitoringStrategy = AvenArgosAccountMonitoringStrategy = {}));
// Backend-only enum; not needed in Rust. Derived by comparing LTV against strategy thresholds.
// This is an instantaneous snapshot — does not reflect ARGOS hysteresis (cancellation thresholds).
var CryptoAccountHealthStatus;
(function (CryptoAccountHealthStatus) {
    CryptoAccountHealthStatus["Healthy"] = "healthy";
    CryptoAccountHealthStatus["Moderate"] = "moderate";
    CryptoAccountHealthStatus["DrawLocked"] = "drawLocked";
    CryptoAccountHealthStatus["MarginCall"] = "marginCall";
    CryptoAccountHealthStatus["Liquidating"] = "liquidating";
    CryptoAccountHealthStatus["WipedOut"] = "wipedOut";
})(CryptoAccountHealthStatus || (exports.CryptoAccountHealthStatus = CryptoAccountHealthStatus = {}));
/** @TranslateToRust @TranslateToPython */
var LiquidationType;
(function (LiquidationType) {
    LiquidationType["TargetLtv"] = "target_ltv";
    LiquidationType["Wipeout"] = "wipeout";
    LiquidationType["ExactCollateralAmount"] = "exact_collateral_amount";
})(LiquidationType || (exports.LiquidationType = LiquidationType = {}));
/** @TranslateToRust */
var CryptoTransferType;
(function (CryptoTransferType) {
    CryptoTransferType["Deposit"] = "deposit";
    CryptoTransferType["Withdrawal"] = "withdrawal";
    CryptoTransferType["Liquidation"] = "liquidation";
})(CryptoTransferType || (exports.CryptoTransferType = CryptoTransferType = {}));
/** @TranslateToRust */
var CryptoTransferStatus;
(function (CryptoTransferStatus) {
    // Deposits: unconfirmed → confirmed
    CryptoTransferStatus["Unconfirmed"] = "unconfirmed";
    CryptoTransferStatus["Confirmed"] = "confirmed";
    // Withdrawals: pending → processing → broadcasted → confirming → confirmed | failed
    //              pending → processing → pending_approval → confirmed | approval_rejected_by_aven
    CryptoTransferStatus["Pending"] = "pending";
    CryptoTransferStatus["Processing"] = "processing";
    CryptoTransferStatus["PendingApproval"] = "pending_approval";
    CryptoTransferStatus["Broadcasted"] = "broadcasted";
    CryptoTransferStatus["Confirming"] = "confirming";
    CryptoTransferStatus["Failed"] = "failed";
    CryptoTransferStatus["ApprovalRejectedByAven"] = "approval_rejected_by_aven";
    // Multi-hop withdrawal intermediates: funding_sender → sender_funded → whitelisting → processing
    CryptoTransferStatus["FundingSender"] = "funding_sender";
    CryptoTransferStatus["SenderFunded"] = "sender_funded";
    CryptoTransferStatus["Whitelisting"] = "whitelisting";
    // Liquidations: submitted → filled → paid_off | failed
    CryptoTransferStatus["Submitted"] = "submitted";
    CryptoTransferStatus["Filled"] = "filled";
    CryptoTransferStatus["PaidOff"] = "paid_off";
    CryptoTransferStatus["Unknown"] = "Unknown";
})(CryptoTransferStatus || (exports.CryptoTransferStatus = CryptoTransferStatus = {}));
/** @TranslateToRust */
var DrawLockStatus;
(function (DrawLockStatus) {
    DrawLockStatus["Active"] = "active";
    DrawLockStatus["Unlocked"] = "unlocked";
})(DrawLockStatus || (exports.DrawLockStatus = DrawLockStatus = {}));
/** @TranslateToRust */
var MarginCallStatus;
(function (MarginCallStatus) {
    MarginCallStatus["Active"] = "active";
    MarginCallStatus["Cancelled"] = "cancelled";
    MarginCallStatus["Liquidated"] = "liquidated";
})(MarginCallStatus || (exports.MarginCallStatus = MarginCallStatus = {}));
